import styled from '@emotion/styled';
import { Box, Col, Text } from '@opendoor/bricks-next';
import type { EntryComponent } from 'cms/entries/entries';
import type { IFcMissionStatement } from 'declarations/contentful';

import { FCContentContainer, FCContentContainerWrapper } from './shared/FCLayout';
import { resizeImageUrl } from './shared/utils';

const BackgroundImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: right center;

  @media (max-width: 420px) {
    object-position: 65% 30%;
  }
`;

// Neutral warm-grey behind the absolutely-positioned photo, so the section
// doesn't flash from page-white to image while the photo decodes.
const PHOTO_FALLBACK_COLOR = '#3F3832';

const RenderFCMissionStatement = (entry: IFcMissionStatement) => {
  const { fields } = entry;

  return (
    <FCContentContainerWrapper
      position="relative"
      overflow="hidden"
      style={{ backgroundColor: PHOTO_FALLBACK_COLOR }}
      $largerThanSM={{
        minHeight: 600,
      }}
    >
      <picture>
        <source media="(min-width: 768px)" srcSet={resizeImageUrl(fields.imageUrl, 1600)} />
        <BackgroundImage
          src={resizeImageUrl(fields.imageUrl, 1536)}
          alt=""
          loading="lazy"
          decoding="async"
        />
      </picture>
      <FCContentContainer
        position="relative"
        zIndex={1}
        alignItems="center"
        justifyContent="center"
        pb="$12x"
      >
        <Box height="50vw" $largerThanSM={{ display: 'none' }} />
        <Col
          backgroundColor="$backgroundPrimary"
          paddingHorizontal="$10x"
          px="$12x"
          py="$24x"
          $largerThanSM={{
            px: '$30x',
            py: '$30x',
          }}
          alignItems="center"
          gap="$5x"
          maxWidth={720}
          borderRadius="$6x"
        >
          <Text
            tag="p"
            $largerThanSM={{
              typography: '$subheaderMedium',
            }}
            typography="$labelLarge"
            textAlign="center"
            style={{ color: '#0040E6' }}
          >
            {fields.title}
          </Text>

          <Text
            tag="p"
            typography="$labelSmall"
            $largerThanSM={{
              typography: '$labelLarge',
            }}
            textAlign="center"
          >
            {fields.body}
          </Text>
        </Col>
      </FCContentContainer>
    </FCContentContainerWrapper>
  );
};

const FCMissionStatement: EntryComponent<IFcMissionStatement> = {
  render: RenderFCMissionStatement,
};

export default FCMissionStatement;
